import { toast } from "react-toastify";

import {
  CreateAgenticLogicRuleRequestBodyType,
  CreateAgenticLogicRuleResponseBodyType,
} from "@intelligems/ig-types/functions/agentic-logic/rules/create";
import { getMutationErrorMessage } from "@src/queryClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const createAgenticLogicRule = async (
  payload: ApiRequest<CreateAgenticLogicRuleRequestBodyType, unknown>
) => {
  const resp = await api.post<
    CreateAgenticLogicRuleResponseBodyType,
    CreateAgenticLogicRuleRequestBodyType
  >(`/v2/agentic-logic/rules`, payload.body);
  return resp.data;
};

export const useCreateAgenticLogicRule = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CreateAgenticLogicRuleResponseBodyType,
    Error,
    ApiRequest<CreateAgenticLogicRuleRequestBodyType, unknown>,
    unknown
  >({
    mutationFn: async (data) => createAgenticLogicRule(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: agenticLogicKeys.rules(),
      });
    },
    onError: (error) => {
      const errorDetail = getMutationErrorMessage(error);
      toast.error(
        `Failed to create rule${errorDetail ? `. ${errorDetail}` : ""}`
      );
    },
  });
};
